import IdCell from 'composites/IdCell';
import DefaultCell from 'composites/DefaultCell';
import StatusCell from 'composites/StatusCell';
import CustomerCell from 'composites/CustomerCell';

import moment from 'moment';
import { Button, IconButton } from '@mui/material';
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import { NavLink } from 'react-router-dom';

const columns = [
  {
    Header: 'id',
    accessor: 'id',
    Cell: ({ value }: any) => <IdCell id={value} />,
  },
  {
    Header: 'status',
    accessor: 'status',
    Cell: ({ value }: any) => {
      let status;

      if (value === 'active') {
        status = <StatusCell icon="done" color="success" status="Active" />;
      } else {
        status = <StatusCell icon="close" color="error" status="Inactive" />;
      }

      return status;
    },
  },
  {
    Header: 'Created at',
    accessor: 'createdAt',
    Cell: ({ value }: any) => <DefaultCell value={value} />,
  },
  {
    Header: 'Next charge at',
    accessor: 'nextChargeAt',
    Cell: ({ value }: any) => <DefaultCell value={value} />,
  },
  {
    Header: 'Full name',
    accessor: 'fullName',
    Cell: ({ value }: any) => (
      <CustomerCell
        // image={data.image}
        color={'dark'}
        name={value}
      />
    ),
  },
  {
    Header: 'email',
    accessor: 'email',
    Cell: ({ value }: any) => {
      return <DefaultCell value={value} suffix={false} />;
    },
  },
  {
    Header: 'price',
    accessor: 'price',
    Cell: ({ value }: any) => <DefaultCell value={value} />,
  },
  {
    Header: 'Actions',
    accessor: 'actions',
    Cell: ({ value }: any) => {
      return (
        <MDBox>
          <NavLink to={`/accounts/new-account?email=${value}`}>
            <MDButton variant="gradient" color="info" onClick={() => {}}>
              edit
            </MDButton>
          </NavLink>
        </MDBox>
      );
    },
  },
];

const setupDataTable = (subaccount: any) => {
  const rows = subaccount.map((subaccount: any, index: number) => ({
    id: index + 1,
    status: subaccount.isActive ? 'active' : 'inactive',
    createdAt: moment(subaccount.startTimeMillis).format('DD/MM/YYYY'),
    nextChargeAt: moment(subaccount.expiryTimeMillis).format('DD/MM/YYYY'),
    fullName: subaccount.fullName,
    email: subaccount.email,
    price: 1,
    actions: subaccount.email,
  }));

  return {
    columns,
    rows,
  };
};

export default setupDataTable;
